/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type ReconciliationMatchStatusV2 =
  | 'Matched'
  | 'MatchedWithDifferences'
  | 'RedeOnly'
  | 'DreamPayOnly'
  | 'Failed';

export const ReconciliationMatchStatusV2 = {
  Matched: 'Matched' as ReconciliationMatchStatusV2,
  MatchedWithDifferences: 'MatchedWithDifferences' as ReconciliationMatchStatusV2,
  RedeOnly: 'RedeOnly' as ReconciliationMatchStatusV2,
  DreamPayOnly: 'DreamPayOnly' as ReconciliationMatchStatusV2,
  Failed: 'Failed' as ReconciliationMatchStatusV2,
};
